import { ViewStyle } from 'react-native';
import { Colors } from './colors';

type ElevationScale = Record<string, ViewStyle>;

const createShadow = (color: string, radius: number, height: number): ViewStyle => ({
  shadowColor: color,
  shadowOpacity: 0.35,
  shadowRadius: radius,
  shadowOffset: { width: 0, height },
  elevation: Math.max(1, Math.round(height * 1.5)),
});

export const Elevation: ElevationScale = {
  level0: {
    shadowColor: 'transparent',
    shadowOpacity: 0,
    shadowRadius: 0,
    shadowOffset: { width: 0, height: 0 },
    elevation: 0,
  },
  level1: createShadow(Colors.shadow.small, 6, 3),
  level2: createShadow(Colors.shadow.medium, 10, 6),
  level3: createShadow(Colors.shadow.large, 18, 10),
};

export type ElevationToken = keyof typeof Elevation;
